import request from './utils/request'
import store from 'store'

class UserService {
  static getUser() {
    return request('GET', 'user/user/')
  }

  static register(user_type, data) {
    // Making sure user_type is passed as a query parameter
    console.log(`Registering with user_type: ${user_type}`)
    return request('POST', `user/register/?user_type=${user_type}`, data)
  }
  static activate(data) {
    return request('POST', 'user/activate/', data)
  }

  static updateAbout(data) {
    return request('PUT', 'user/user/', data)
  }

  static deleteUser(data) {
    return request('DELETE', 'user/user/', data)
  }

  static updateNamePicture(role, data) {
    return request('POST', 'user/user-tutor-or-student/', data, { user_type: role })
  }

  static getStudentGoal() {
    return request('GET', 'user/student-goals/')
  }

  static createStudentGoal(data) {
    return request('POST', 'user/student-goals/', data)
  }

  static editStudentGoal(id, data) {
    return request('PUT', `user/student-goals/${id}/`, data)
  }

  static getRandomTest(data) {
    return request('GET', 'test/random-questions/', undefined, data.params)
  }

  static cancelTest(data) {
    return request('POST', 'test/cancel-test/', data)
  }

  static submitTest(data) {
    return request('POST', 'test/submit-answers/', data, undefined, {
      'Content-Type': 'multipart/form-data',
    })
  }

  // static submitTest(data) {
  //   return request('POST', 'test/submit-answers/', data)
  // }

  static createBanner(data) {
    // return request('POST', 'class/classbanner/', data)
    return request('POST', 'class/classbanner/', data, undefined, {
      'Content-Type': 'multipart/form-data',
    })
  }
  static updateRegistraionAbout(data) {
    return request('PUT', 'user/user/', data, undefined, {
      'Content-Type': 'multipart/form-data',
    })
  }

  static getBanner(id) {
    return request('GET', `class/classbanner/${id}`)
  }

  static getBanners(page = 1) {
    return request('GET', '/class/classbanner/', undefined, { page })
  }

  static editBanner(id, data) {
    return request('PUT', `class/classbanner/${id}`, data, undefined, {
      'Content-Type': 'multipart/form-data',
    })
  }

  static updateEntity(id, data) {
    return request('PUT', `entity/entity/${id}`, data, undefined, {
      'Content-Type': 'multipart/form-data',
    })
  }

  static fetchAvailableEvents() {
    return request('GET', 'class/availabilitycalendar/')
  }

  static addNewAvailabilities(data) {
    return request('POST', 'class/availabilitycalendar/', data)
  }

  static getClassBannerCategories() {
    return request('GET', 'class/classbannerCategory/')
  }

  static getTutorTestRecords() {
    return request('GET', 'test/tutor-test-record/?page_size=100')
  }

  static getTestCategories() {
    return request('GET', 'test/testcategory/')
  }

  static signIn(data, role = null) {
    // Use provided role if specified, but don't default to student
    // since the action handles the role order
    const targetRole = role || ''

    console.log(
      `Attempting login with role type: "${targetRole || 'none'}" for email: ${data.email}`
    )

    // Ensure payload matches expected format
    const formattedData = {
      email: data.email,
      password: data.password,
      // If using OTP, include it
      ...(data.otp ? { otp: data.otp } : {}),
      // Include user agent info if available
      ...(data.user_agent ? { user_agent: data.user_agent } : {}),
    }

    // Only include user_type in URL if a role is specified
    const url = targetRole ? `user/login/?user_type=${targetRole}` : 'user/login/'
    console.log(`Login request URL: ${url}`)

    return request('POST', url, formattedData)
      .then((response) => {
        // Log the actual response structure (without sensitive data)
        console.log(
          `Login response for ${targetRole || 'unspecified'} role:`,
          JSON.stringify(
            {
              status: response.status,
              has_data: !!response.data,
              has_tokens: !!(response.data && (response.data.access || response.data.data?.access)),
            },
            null,
            2
          )
        )
        return response
      })
      .catch((error) => {
        // Log specific error details to help with debugging
        console.error(`Login error for ${targetRole || 'unspecified'} role:`, {
          status: error.response?.status,
          statusText: error.response?.statusText,
          url: error.config?.url,
          errorMessage: error.response?.data?.error || error.message,
          hasResponse: !!error.response,
          errorType:
            error.response?.status === 403
              ? 'forbidden_access'
              : error.response?.data?.error &&
                  error.response?.data?.error.includes('Tutor profile not found')
                ? 'tutor_profile_not_found'
                : 'other',
        })

        // Add special handling for 403 errors to be more explicit
        if (error.response?.status === 403) {
          console.warn(
            `403 Forbidden response for ${targetRole} login. This may indicate role access restrictions or account issues.`
          )
          // Add a custom property to the error to make it easier to identify in the catch block
          error.isForbiddenError = true
        }

        throw error
      })
  }

  static getPaymentOptions() {
    return request('GET', 'class/paymentoptions/')
  }

  static deleteClassBanner(hash) {
    return request('DELETE', `class/classbanner/${hash}`)
  }

  static getMainCategories() {
    return request('GET', 'main/maincategory/')
  }

  static activateTwoFactorAuth(data) {
    return request('POST', 'user/activate-two-factor/', data)
  }

  static deactivateTwoFactorAuth() {
    return request('POST', 'user/deactivate-two-factor/')
  }

  static changePassword(data) {
    return request('POST', 'user/password/change/', data)
  }

  static sendResetPasswordEmail(data) {
    return request('POST', 'user/password/reset/', data)
  }

  static resetPassword(data) {
    return request('POST', 'user/password-reset/confirm/', data)
  }

  static searchClassBanners(params = {}) {
    return request('GET', 'class_search/classbanner/', undefined, params).catch((error) => {
      // Provide fallback data if the endpoint returns an error
      console.warn('Class banner API error, providing fallback data:', error)
      // return {
      //   data: {
      //     data: [], // Empty array as fallback
      //     error: null,
      //   },
      //   status: 200,
      // }
    })
  }

  /* static searchClassBanners(params = {}) {
    return request('GET', 'class_search/classbanner/:id', undefined, params);
  } */

  static getLoginHistory(page = 1) {
    return request('GET', 'user/login-history-records/', undefined, { page })
  }

  static getLinkedDevices(page = 1) {
    return request('GET', 'user/linked-devices/', undefined, { page })
  }

  static logoutFromAllDevices() {
    return request('POST', 'user/logout-all-devices/')
  }

  static logout() {
    return request('POST', 'user/logout/')
  }

  static sendConfirmation(email) {
    return request('POST', 'user/resend-activation/', email)
  }

  static initiateTest(data) {
    return request('POST', '/test/initiate-test/', data)
  }

  static getVerification(data) {
    return request('POST', 'kyc/initiate/', data)
  }
  static getVerificationStatus(id) {
    return request('GET', `kyc/status/${id}`)
  }
  static getTutors() {
    return request('GET', 'tutor_search')
  }
  static tutorSearchWithFilters(data) {
    return request('POST', 'tutor_search/search_with_filters', data)
  }
}
export default UserService
